<template>
    <span class="infoArquivo">
        {{ arquivo.NomeOriginal }}
        <btn-download-component :fazerDownload="verArquivo" :parametros="arquivo.CodArquivo" icone="eye" texto="Ver"
            class="ml-4" />
        <btn-excluir-component v-if="canRemove" :idItem="arquivo.CodArquivo" :excluirItem="removerArquivo" class="ml-2" />
    </span>
</template>

<script>
import BtnDownloadComponent from "@/components/shared/btn-download.vue";
import BtnExcluirComponent from "@/components/shared/btn-excluir.vue";

export default {
    props: {
        arquivo: {
            type: Object,
            required: true
        },
        canRemove: {
            type: Boolean,
            default: false
        },
    },
    components: { BtnDownloadComponent, BtnExcluirComponent },
    methods: {
        verArquivo(cod) {
            this.$emit('verarquivo', cod)
        },
        removerArquivo(cod) {
            this.$emit('removerarquivo', cod)
        }
    },
    mounted() {
        //console.log('VerApagarArquivo recebeu', this.arquivo.NomeOriginal)
    }
}
</script>

<style scoped>
span.infoArquivo {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
}

span.badge {
    cursor: pointer;
    width: 1.5rem;
}
</style>